var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import MuiTab from '@material-ui/core/Tab';
import classnames from 'classnames';
import { useTranslate, useFormGroup } from 'ra-core';
import { useForm } from 'react-final-form';
export var FormTabHeader = function (_a) {
    var _b;
    var classes = _a.classes, label = _a.label, value = _a.value, icon = _a.icon, className = _a.className, rest = __rest(_a, ["classes", "label", "value", "icon", "className"]);
    var translate = useTranslate();
    var location = useLocation();
    var formGroup = useFormGroup(value);
    var form = useForm();
    var _c = React.useState(false), showError = _c[0], setShowError = _c[1];
    useEffect(function () {
        var unsubscribe = form.subscribe(function (state) {
            if (!showError && (state.submitting || state.submitFailed)) {
                setShowError(true);
            }
        }, { submitting: true, submitFailed: true });
        return unsubscribe;
    }, [form, showError]);
    return (React.createElement(MuiTab, __assign({ label: translate(label, { _: label }), value: value, icon: icon, className: classnames('form-tab', className, (_b = {},
            _b[classes.errorTabButton] = formGroup.invalid &&
                (formGroup.touched || showError) &&
                location.pathname !== value,
            _b)), component: Link, to: __assign(__assign({}, location), { pathname: value }), id: "tabheader-" + value, "aria-controls": "tabpanel-" + value }, rest)));
};
